import InfoIcon from "@/assets/icons/authentication/InfoIconOrangeSm.svg";

type ComfortBlockProps = {
  title: string;
  description?: string;
  subDescription?: string;
  options: string[];

  // ✅ add these
  value: string;
  onChange: (val: string) => void;

  // (optional) if you want stable radio group names:
  name?: string;
};

const ComfortBlock = ({
  title,
  description,
  subDescription,
  options,
  value,
  onChange,
  name,
}: ComfortBlockProps) => {
  const groupName = name ?? title; // radio group name

  return (
    <div className="bg-[#F9FAFB] border border-[#EAECF0] rounded-lg p-3">
      <div className="mb-2">
        <p className="text-xs font-medium text-[#121217]">{title}</p>

        {subDescription && (
          <div className="flex items-center gap-1">
            <InfoIcon />
            <p className="text-[10px] text-[#475467] mt-0.5 italic">
              {subDescription}
            </p>
          </div>
        )}
      </div>

      <div className="flex flex-wrap gap-3 lg:gap-6">
        {options.map((opt) => {
          const isChecked = value === opt;

          return (
            <label
              key={opt}
              className="flex items-center gap-2 cursor-pointer group select-none"
            >
              <div className="relative flex items-center justify-center">
                <input
                  type="radio"
                  name={groupName}
                  value={opt}
                  checked={isChecked}
                  onChange={() => onChange(opt)}
                  className="sr-only"
                />

                {/* Custom Radio */}
                <div
                  className={`
              w-4 h-4
              rounded-full
              border
              transition-all
              duration-200
              flex items-center justify-center
              ${
                isChecked
                  ? "border-[#F97316]"
                  : "border-[#D0D5DD] group-hover:border-[#F97316]"
              }
            `}
                >
                  <div
                    className={`
                w-2 h-2
                rounded-full
                bg-[#F97316]
                transition-all
                duration-200
                ${isChecked ? "scale-100 opacity-100" : "scale-0 opacity-0"}
              `}
                  />
                </div>
              </div>

              <span className="text-sm text-[#344054]">{opt}</span>
            </label>
          );
        })}
      </div>
    </div>
  );
};

export default ComfortBlock;
